import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template as TextHighlightTemplate } from "./text-highlight.templates";

export default {
    title: "Website/Partial Templates/Text Highlight",
    render: TextHighlightTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        background: "",
        withBodyText: true,
        withHeadline: true,
        withButton: true,
        withTags: true,
        headline: "h2",
    },
    argTypes: {
        background: {
            options: ["white", "grey", "blue", "green"],
            control: { type: "radio" },
        },
        withButton: {
            control: "boolean",
        },
        withHeadline: {
            control: "boolean",
        },
        withBodyText: {
            control: "boolean",
        },
        withTags: {
            control: "boolean",
        },
        headline: {
            options: ["h1", "h2"],
            control: { type: "radio" },
        },
    },
};

export const Default = {};
